"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKpoDataAndMappingToList = getKpoDataAndMappingToList;
exports.getAllKpoInYearDataAndMappingToList = getAllKpoInYearDataAndMappingToList;
exports.getKpoDataOverviewAndMappingToList = getKpoDataOverviewAndMappingToList;
exports.getKpoPrintDataAndMaping = getKpoPrintDataAndMaping;
var common_1 = require("../common");
var api_stubs_1 = require("../../api-stubs");
// Note: API functions (getKpoData, getKpoPrintingPage, getAllKpoInYearData) should be implemented by consuming application
// TimeDelayInMs constant should be passed as parameter or defined in consuming app
/**
 * Funkcja pobiera dane z getKpoData,
 * @param {EupType} eupType - dane wybranego EUP
 * @param {Date} DateFrom - data początkowa
 * @param {Date} DateTo - data końcowa
*/
function getKpoDataAndMappingToList(eupType, 
//Year: number,
DateFrom, DateTo) {
    return __awaiter(this, void 0, void 0, function () {
        var pageSize, pageNumber, totalPagesNumber, hasPreviousPage, hasNextPage, kpoCardList, data, mappedItems, _i, kpoCardList_1, kpoCard, kpoDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pageSize = 50;
                    pageNumber = 1;
                    hasPreviousPage = false;
                    hasNextPage = false;
                    kpoCardList = [];
                    _a.label = 1;
                case 1: return [4 /*yield*/, getKpoData(eupType.clientId, eupType.clientSecret, eupType.eupId, pageNumber, pageSize, DateFrom, DateTo)];
                case 2:
                    data = _a.sent();
                    // Sprawdź, czy dane zostały poprawnie pobrane
                    if (!data || !data.items || data.items.length === 0) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKpoDataAndMappingToList - No Data", properties: { clientId: eupType.clientId, eupId: eupType.eupId, DateFrom: DateFrom?.toISOString(), DateTo: DateTo?.toISOString() } });
                        //throw new Error("Brak danych do raportu dla zadanych kryteriów.");
                    }
                    else if (data.error) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKpoDataAndMappingToList - Error", properties: { clientId: eupType.clientId, eupId: eupType.eupId, DateFrom: DateFrom.toISOString(), DateTo: DateTo.toISOString(), errorMessage: data.error.message } });
                        //throw new Error(`Błąd podczas pobierania danych KPO: ${data.error.message}`);
                    }
                    mappedItems = data.items.map(function (item) { return ({
                        kpoId: item.kpoId,
                        cardNumber: item.cardNumber,
                        cardStatus: item.cardStatus,
                        cardStatusCodeName: item.cardStatusCodeName,
                        wasteCode: item.wasteCode,
                        wasteCodeDescription: item.wasteCodeDescription,
                        kpoLastModifiedAt: new Date(item.kpoLastModifiedAt)
                    }); });
                    kpoCardList.push.apply(kpoCardList, mappedItems);
                    totalPagesNumber = data.totalPagesNumber;
                    hasPreviousPage = data.hasPreviousPage;
                    hasNextPage = data.hasNextPage;
                    pageNumber++;
                    _a.label = 3;
                case 3:
                    if (hasNextPage && pageNumber <= totalPagesNumber) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4:
                    // Sprawdź, czy lista KpoCardList nie jest pusta i dla kadego wybranego kpoId z listy KpoCardList pobierz dane szczegółowe funkcją getKpoPrintingPage
                    if (kpoCardList.length === 0) {
                        return [2 /*return*/, kpoCardList]; // Zwróć pustą listę, jeśli nie ma żadnych danych
                    }
                    _i = 0, kpoCardList_1 = kpoCardList;
                    _a.label = 5;
                case 5:
                    if (!(_i < kpoCardList_1.length)) return [3 /*break*/, 9];
                    kpoCard = kpoCardList_1[_i];
                    return [4 /*yield*/, getKpoPrintingPage(eupType.clientId, eupType.clientSecret, kpoCard.cardNumber, eupType.eupId, kpoCard.kpoId)];
                case 6:
                    kpoDetails = _a.sent();
                    // Sprawdź, czy dane zostały poprawnie pobrane
                    if (!kpoDetails) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKpoDataAndMappingToList - No Details", properties: { kpoId: kpoCard.kpoId, cardNumber: kpoCard.cardNumber } });
                        throw new Error("Nie uda\u0142o si\u0119 pobra\u0107 szczeg\u00F3\u0142owych danych KPO dla karty: ".concat(kpoCard.cardNumber, ". Spr\u00F3buj ponownie pobra\u0107 dane do raportu."));
                    }
                    // Mapowanie szczegółowych danych do KpoCard
                    kpoCard.correctedWasteMass = kpoDetails.correctedWasteMass;
                    kpoCard.plannedTransportDate = kpoDetails.plannedTransportDate;
                    kpoCard.plannedTransportTime = kpoDetails.plannedTransportTime;
                    kpoCard.isWasteGenerating = kpoDetails.isWasteGenerating;
                    kpoCard.wasteGeneratedTerytPk = kpoDetails.wasteGeneratedTerytPk;
                    kpoCard.wasteGeneratedDistrict = kpoDetails.wasteGeneratedDistrict;
                    kpoCard.wasteGeneratedProvince = kpoDetails.wasteGeneratedProvince;
                    kpoCard.wasteGeneratedCommune = kpoDetails.wasteGeneratedCommune;
                    kpoCard.additionalInfo = kpoDetails.additionalInfo;
                    kpoCard.wasteGeneratingAdditionalInfo = kpoDetails.wasteGeneratingAdditionalInfo;
                    kpoCard.calendarYear = kpoDetails.calendarYear;
                    kpoCard.senderNameOrFirstNameAndLastName = kpoDetails.senderNameOrFirstNameAndLastName;
                    kpoCard.senderAddress = kpoDetails.senderAddress;
                    kpoCard.senderEupNumber = kpoDetails.senderEupNumber;
                    kpoCard.senderEupName = kpoDetails.senderEupName;
                    kpoCard.senderEupAddress = kpoDetails.senderEupAddress;
                    kpoCard.senderIdentificationNumber = kpoDetails.senderIdentificationNumber;
                    kpoCard.senderNip = kpoDetails.senderNip;
                    kpoCard.senderNipEu = kpoDetails.senderNipEu;
                    kpoCard.carrierNameOrFirstNameAndLastName = kpoDetails.carrierNameOrFirstNameAndLastName;
                    kpoCard.carrierAddress = kpoDetails.carrierAddress;
                    kpoCard.carrierIdentificationNumber = kpoDetails.carrierIdentificationNumber;
                    kpoCard.carrierNip = kpoDetails.carrierNip;
                    kpoCard.carrierNipEu = kpoDetails.carrierNipEu;
                    kpoCard.receiverNameOrFirstNameAndLastName = kpoDetails.receiverNameOrFirstNameAndLastName;
                    kpoCard.receiverAddress = kpoDetails.receiverAddress;
                    kpoCard.receiverEupNumber = kpoDetails.receiverEupNumber;
                    kpoCard.receiverEupName = kpoDetails.receiverEupName;
                    kpoCard.receiverEupAddress = kpoDetails.receiverEupAddress;
                    kpoCard.receiverIdentificationNumber = kpoDetails.receiverIdentificationNumber;
                    kpoCard.receiverNip = kpoDetails.receiverNip;
                    kpoCard.receiverNipEu = kpoDetails.receiverNipEu;
                    kpoCard.wasteCodeAndDescription = kpoDetails.wasteCodeAndDescription;
                    kpoCard.wasteMass = kpoDetails.wasteMass;
                    kpoCard.certificateNumber = kpoDetails.certificateNumber;
                    kpoCard.wasteProcess = kpoDetails.wasteProcess;
                    kpoCard.wasteProcessWithCode = kpoDetails.wasteProcessWithCode;
                    kpoCard.remarks = kpoDetails.remarks;
                    kpoCard.vehicleRegNumber = kpoDetails.vehicleRegNumber;
                    kpoCard.realTransportDate = kpoDetails.realTransportDate;
                    kpoCard.realTransportTime = kpoDetails.realTransportTime;
                    kpoCard.receiveConfirmationDate = kpoDetails.receiveConfirmationDate;
                    kpoCard.receiveConfirmationTime = kpoDetails.receiveConfirmationTime;
                    kpoCard.approvalDate = kpoDetails.approvalDate;
                    kpoCard.approvalTime = kpoDetails.approvalTime;
                    kpoCard.approvedByUser = kpoDetails.approvedByUser;
                    kpoCard.transportConfirmationDate = kpoDetails.transportConfirmationDate;
                    kpoCard.transportConfirmationTime = kpoDetails.transportConfirmationTime;
                    kpoCard.transportConfirmedByUser = kpoDetails.transportConfirmedByUser;
                    kpoCard.receiveConfirmedByUser = kpoDetails.receiveConfirmedByUser;
                    kpoCard.wasteCodeExtended = kpoDetails.wasteCodeExtended;
                    // Oczekiwanie 0.5 sekundy przed ponownym pobraniem danych
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, api_stubs_1.TimeDelayInMs); })];
                case 7:
                    // Oczekiwanie 0.5 sekundy przed ponownym pobraniem danych
                    _a.sent(); // 500 ms = 0.5 sekundy
                    _a.label = 8;
                case 8:
                    _i++;
                    return [3 /*break*/, 5];
                case 9: 
                // Teraz możesz zwrócić dane lub je przetworzyć
                return [2 /*return*/, kpoCardList];
            }
        });
    });
}
/**
 * Funkcja pobiera dane z getAllKpoInYearData.
 * @param {EupType} eupType - dane wybranego EUP
 * @param {number} Year - rok
 */
function getAllKpoInYearDataAndMappingToList(eupType, Year) {
    return __awaiter(this, void 0, void 0, function () {
        var pageSize, pageNumber, totalPagesNumber, hasPreviousPage, hasNextPage, KpoCardShortList, data, mappedItems;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pageSize = 50;
                    pageNumber = 1;
                    hasPreviousPage = false;
                    hasNextPage = false;
                    KpoCardShortList = [];
                    _a.label = 1;
                case 1: return [4 /*yield*/, getAllKpoInYearData(eupType.clientId, eupType.clientSecret, eupType.eupId, Year, pageNumber, pageSize)];
                case 2:
                    data = _a.sent();
                    if (!data || !data.items || data.items.length === 0) {
                        //appInsights.trackEvent({ name: "getAllKpoInYearDataAndMappingToList - No Data", properties: { clientId: eupType.clientId, eupId: eupType.eupId, Year: Year.toString() } });
                        //throw new Error("Brak danych do raportu dla zadanych kryteriów.");
                    }
                    else if (data.error) {
                        //appInsights.trackEvent({ name: "getAllKpoInYearDataAndMappingToList - Error", properties: { clientId: eupType.clientId, eupId: eupType.eupId, Year: Year.toString(), errorMessage: data.error.message } });
                        //throw new Error(`Błąd podczas pobierania danych KPO: ${data.error.message}`);
                    }
                    mappedItems = data.items.map(function (item) { return ({
                        // "PlannedTransportTime": "2025-07-06T06:32:59.466Z",
                        plannedTransportTime: item.plannedTransportTime ? new Date(item.plannedTransportTime) : null,
                        //  "RealTransportTime": "2025-07-06T06:32:59.466Z",
                        realTransportTime: item.realTransportTime ? new Date(item.realTransportTime) : null,
                        //  "WasteCode": "string",
                        wasteCode: item.wasteCode,
                        //  "WasteCodeDescription": "string",
                        wasteCodeDescription: item.wasteCodeDescription,
                        //  "VehicleRegNumber": "string",
                        vehicleRegNumber: item.vehicleRegNumber,
                        //  "CardStatus": "string",
                        cardStatus: item.cardStatus || "", // Użyj domyślnej wartości pustego stringa, jeśli cardStatus jest undefined
                        //  "CardNumber": "string",
                        cardNumber: item.cardNumber,
                        //  "CardStatusCodeName": "string",
                        cardStatusCodeName: item.cardStatusCodeName || "", // Użyj domyślnej wartości pustego stringa, jeśli cardStatusCodeName jest undefined
                        //  "SenderName": "string",
                        senderNameOrFirstNameAndLastName: item.senderFirstNameAndLastName || "", // Użyj domyślnej wartości pustego stringa, jeśli senderFirstNameAndLastName jest undefined
                        //  "ReceiverName": "string",
                        receiverNameOrFirstNameAndLastName: item.receiverFirstAndLastName || "", // Użyj domyślnej wartości pustego stringa, jeśli receiverFirstAndLastName jest undefined
                        //  "KpoId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        kpoId: item.kpoId,
                        //  "KpoLastModifiedAt": "2025-07-06T06:32:59.466Z",
                        kpoLastModifiedAt: new Date(item.kpoLastModifiedAt),
                        //  "SenderFirstNameAndLastName": "string",
                        senderFirstNameAndLastName: item.senderFirstNameAndLastName || "", // Użyj domyślnej wartości pustego stringa, jeśli senderFirstNameAndLastName jest undefined
                        //  "ReceiverFirstAndLastName": "string",
                        receiverFirstAndLastName: item.receiverFirstAndLastName || "", // Użyj domyślnej wartości pustego stringa, jeśli receiverFirstAndLastName jest undefined
                        //  "RevisionNumber": 0,
                        revisionNumber: item.revisionNumber || 0, // Użyj domyślnej wartości 0, jeśli revisionNumber jest undefined
                        //  "CardRejectionTime": "2025-07-06T06:32:59.466Z",
                        cardRejectionTime: item.cardRejectionTime ? new Date(item.cardRejectionTime) : null, // Użyj domyślnej wartości null, jeśli cardRejectionTime jest undefined
                        //  "WasteCodeExtended": true,
                        wasteCodeExtended: item.wasteCodeExtended || false, // Użyj domyślnej wartości false, jeśli wasteCodeExtended jest undefined
                        //  "WasteCodeExtendedDescription": "string",
                        wasteCodeExtendedDescription: item.wasteCodeExtendedDescription || "", // Użyj domyślnej wartości pustego stringa, jeśli wasteCodeExtendedDescription jest undefined
                        //  "HazardousWasteReclassification": true,
                        hazardousWasteReclassification: item.hazardousWasteReclassification || false, // Użyj domyślnej wartości false, jeśli hazardousWasteReclassification jest undefined
                        //  "HazardousWasteReclassificationDescription": "string"
                        hazardousWasteReclassificationDescription: item.hazardousWasteReclassificationDescription || "" // Użyj domyślnej wartości pustego stringa, jeśli hazardousWasteReclassificationDescription jest undefined
                    }); });
                    KpoCardShortList.push.apply(KpoCardShortList, mappedItems);
                    totalPagesNumber = data.totalPagesNumber;
                    hasPreviousPage = data.hasPreviousPage;
                    hasNextPage = data.hasNextPage;
                    pageNumber++;
                    _a.label = 3;
                case 3:
                    if (hasNextPage && pageNumber <= totalPagesNumber) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4:
                    // Sprawdź, czy lista KpoCardList nie jest pusta i dla kadego wybranego kpoId z listy KpoCardList pobierz dane szczegółowe funkcją getKpoPrintingPage
                    if (KpoCardShortList.length === 0) {
                        return [2 /*return*/, KpoCardShortList]; // Zwróć pustą listę, jeśli nie ma żadnych danych
                    }
                    return [2 /*return*/, KpoCardShortList];
            }
        });
    });
}
/**
 *
 * @param eupType
 * @param DateFrom
 * @param DateTo
 * @returns
 */
function getKpoDataOverviewAndMappingToList(eupType, 
//Year: number,
DateFrom, DateTo) {
    return __awaiter(this, void 0, void 0, function () {
        var pageSize, pageNumber, totalPagesNumber, hasPreviousPage, hasNextPage, KpoCardShortList, data, mappedItems;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pageSize = 50;
                    pageNumber = 1;
                    hasPreviousPage = false;
                    hasNextPage = false;
                    KpoCardShortList = [];
                    _a.label = 1;
                case 1: return [4 /*yield*/, getKpoData(eupType.clientId, eupType.clientSecret, eupType.eupId, pageNumber, pageSize, DateFrom, DateTo)];
                case 2:
                    data = _a.sent();
                    if (!data || !data.items || data.items.length === 0) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKpoDataAndMappingToList - No Data", properties: { clientId: eupType.clientId, eupId: eupType.eupId, DateFrom: DateFrom?.toISOString(), DateTo: DateTo?.toISOString() } });
                        //throw new Error("Brak danych do raportu dla zadanych kryteriów.");
                    }
                    else if (data.error) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKpoDataAndMappingToList - Error", properties: { clientId: eupType.clientId, eupId: eupType.eupId, DateFrom: DateFrom?.toISOString(), DateTo: DateTo?.toISOString(), errorMessage: data.error.message } });
                        //throw new Error(`Błąd podczas pobierania danych KPO: ${data.error.message}`);
                    }
                    mappedItems = data.items.map(function (item) { return ({
                        // "PlannedTransportTime": "2025-07-06T06:32:59.466Z",
                        plannedTransportTime: item.plannedTransportTime ? new Date(item.plannedTransportTime) : null,
                        //  "RealTransportTime": "2025-07-06T06:32:59.466Z",
                        realTransportTime: item.realTransportTime ? new Date(item.realTransportTime) : null,
                        //  "WasteCode": "string",
                        wasteCode: item.wasteCode,
                        //  "WasteCodeDescription": "string",
                        wasteCodeDescription: item.wasteCodeDescription,
                        //  "VehicleRegNumber": "string",
                        vehicleRegNumber: item.vehicleRegNumber,
                        //  "CardStatus": "string",
                        cardStatus: item.cardStatus || "", // Użyj domyślnej wartości pustego stringa, jeśli cardStatus jest undefined
                        //  "CardNumber": "string",
                        cardNumber: item.cardNumber,
                        //  "CardStatusCodeName": "string",
                        cardStatusCodeName: item.cardStatusCodeName || "", // Użyj domyślnej wartości pustego stringa, jeśli cardStatusCodeName jest undefined
                        //  "SenderName": "string",
                        senderNameOrFirstNameAndLastName: item.senderFirstNameAndLastName || "", // Użyj domyślnej wartości pustego stringa, jeśli senderFirstNameAndLastName jest undefined
                        //  "ReceiverName": "string",
                        receiverNameOrFirstNameAndLastName: item.receiverFirstAndLastName || "", // Użyj domyślnej wartości pustego stringa, jeśli receiverFirstAndLastName jest undefined
                        //  "KpoId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        kpoId: item.kpoId,
                        //  "KpoLastModifiedAt": "2025-07-06T06:32:59.466Z",
                        kpoLastModifiedAt: new Date(item.kpoLastModifiedAt),
                        //  "SenderFirstNameAndLastName": "string",
                        senderFirstNameAndLastName: item.senderFirstNameAndLastName || "", // Użyj domyślnej wartości pustego stringa, jeśli senderFirstNameAndLastName jest undefined
                        //  "ReceiverFirstAndLastName": "string",
                        receiverFirstAndLastName: item.receiverFirstAndLastName || "", // Użyj domyślnej wartości pustego stringa, jeśli receiverFirstAndLastName jest undefined
                        //  "RevisionNumber": 0,
                        revisionNumber: item.revisionNumber || 0, // Użyj domyślnej wartości 0, jeśli revisionNumber jest undefined
                        //  "CardRejectionTime": "2025-07-06T06:32:59.466Z",
                        cardRejectionTime: item.cardRejectionTime ? new Date(item.cardRejectionTime) : null, // Użyj domyślnej wartości null, jeśli cardRejectionTime jest undefined
                        //  "WasteCodeExtended": true,
                        wasteCodeExtended: item.wasteCodeExtended || false, // Użyj domyślnej wartości false, jeśli wasteCodeExtended jest undefined
                        //  "WasteCodeExtendedDescription": "string",
                        wasteCodeExtendedDescription: item.wasteCodeExtendedDescription || "", // Użyj domyślnej wartości pustego stringa, jeśli wasteCodeExtendedDescription jest undefined
                        //  "HazardousWasteReclassification": true,
                        hazardousWasteReclassification: item.hazardousWasteReclassification || false, // Użyj domyślnej wartości false, jeśli hazardousWasteReclassification jest undefined
                        //  "HazardousWasteReclassificationDescription": "string"
                        hazardousWasteReclassificationDescription: item.hazardousWasteReclassificationDescription || "" // Użyj domyślnej wartości pustego stringa, jeśli hazardousWasteReclassificationDescription jest undefined
                    }); });
                    KpoCardShortList.push.apply(KpoCardShortList, mappedItems);
                    totalPagesNumber = data.totalPagesNumber;
                    hasPreviousPage = data.hasPreviousPage;
                    hasNextPage = data.hasNextPage;
                    pageNumber++;
                    _a.label = 3;
                case 3:
                    if (hasNextPage && pageNumber <= totalPagesNumber) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4:
                    // Sprawdź, czy lista KpoCardList nie jest pusta i dla kadego wybranego kpoId z listy KpoCardList pobierz dane szczegółowe funkcją getKpoPrintingPage
                    if (KpoCardShortList.length === 0) {
                        return [2 /*return*/, KpoCardShortList]; // Zwróć pustą listę, jeśli nie ma żadnych danych
                    }
                    // Teraz możesz zwrócić dane lub je przetworzyć
                    return [2 /*return*/, KpoCardShortList];
            }
        });
    });
}
/**
 * Funkcja getKpoPrintDataAndMaping pobiera dane szczegółowe KPO do wydruku. Realizuje to w kilku krokach:
 1. Z przekazanego numeru karty KPO (cardNumber) wyodrębnia rok metodą extractYearFromKpoCardNumber.
 2. Pobiera wszytkie karty KPO dla danego roku metodą BdoApiClient.getAllKpoInYearData. Sprawdza, czy dane zostały poprawnie pobrane i czy nie są puste.
 3. Wyszukiwanie karty KPO: Otrzymane dane są następnie przeszukiwane w celu znalezienia karty KPO odpowiadającej podanemu numerowi karty (cardNumber) i pobraniu KpoId.
 4. Wywołanie getKpoPrintingPage: Po znalezieniu odpowiedniego KpoId, funkcja wywołuje BdoApiClient.getKpoPrintingPage, przekazując clientId, clientSecret, cardNumber, kpoId oraz eupId, aby pobrać szczegółowe dane KPO do wydruku.
 5. Zwrócenie danych: Na końcu funkcja zwraca obiekt KpoCardPrintResult, który zawiera wszystkie niezbędne informacje do wydruku karty KPO oraz metadane (kpoId, cardNumber, cardStatus) do optymalizacji pobierania PDF.
*/
function getKpoPrintDataAndMaping(eupType, cardNumber) {
    return __awaiter(this, void 0, void 0, function () {
        var year, pageSize, pageNumber, totalPagesNumber, hasPreviousPage, hasNextPage, KpoCardShortList, data, mappedItems, kpoItem, kpoId, cardStatus, kpoPrintData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    year = (0, common_1.extractYearFromKpoCardNumber)(cardNumber);
                    if (!year) {
                        throw new Error("Nie uda\u0142o si\u0119 wyodr\u0119bni\u0107 roku z numeru karty KPO: ".concat(cardNumber));
                    }
                    pageSize = 50;
                    pageNumber = 1;
                    hasPreviousPage = false;
                    hasNextPage = false;
                    KpoCardShortList = [];
                    _a.label = 1;
                case 1: return [4 /*yield*/, getAllKpoInYearData(eupType.clientId, eupType.clientSecret, eupType.eupId, year, pageNumber, pageSize)];
                case 2:
                    data = _a.sent();
                    if (!data || !data.items || data.items.length === 0) {
                        //appInsights.trackEvent({ name: "getAllKpoInYearDataAndMappingToList - No Data", properties: { clientId: eupType.clientId, eupId: eupType.eupId, Year: Year.toString() } });
                        //throw new Error("Brak danych do raportu dla zadanych kryteriów.");
                    }
                    else if (data.error) {
                        //appInsights.trackEvent({ name: "getAllKpoInYearDataAndMappingToList - Error", properties: { clientId: eupType.clientId, eupId: eupType.eupId, Year: Year.toString(), errorMessage: data.error.message } });
                        //throw new Error(`Błąd podczas pobierania danych KPO: ${data.error.message}`);
                    }
                    mappedItems = data.items.map(function (item) { return ({
                        kpoId: item.kpoId,
                        cardNumber: item.cardNumber,
                        cardStatus: item.cardStatus
                    }); });
                    KpoCardShortList.push.apply(KpoCardShortList, mappedItems);
                    totalPagesNumber = data.totalPagesNumber;
                    hasPreviousPage = data.hasPreviousPage;
                    hasNextPage = data.hasNextPage;
                    pageNumber++;
                    _a.label = 3;
                case 3:
                    if (hasNextPage && pageNumber <= totalPagesNumber) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4:
                    if (KpoCardShortList.length === 0) {
                        throw new Error("Brak danych KPO dla roku ".concat(year, " i MPD: ").concat(eupType.identificationNumber));
                    }
                    kpoItem = KpoCardShortList.find(function (item) { return item.cardNumber === cardNumber; });
                    if (!kpoItem) {
                        throw new Error("Nie znaleziono karty KPO o numerze: ".concat(cardNumber, "."));
                    }
                    kpoId = kpoItem.kpoId;
                    cardStatus = kpoItem.cardStatus;
                    return [4 /*yield*/, getKpoPrintingPage(eupType.clientId, eupType.clientSecret, cardNumber, eupType.eupId, kpoId)];
                case 5:
                    kpoPrintData = _a.sent();
                    if (!kpoPrintData) {
                        throw new Error("Nie uda\u0142o si\u0119 pobra\u0107 danych do wydruku dla karty KPO o numerze: ".concat(cardNumber));
                    }
                    // 5. Zwróć dane do wydruku wraz z metadanymi (optymalizacja dla pobierania PDF)
                    return [2 /*return*/, {
                            printData: kpoPrintData,
                            metadata: {
                                kpoId: kpoId,
                                cardNumber: cardNumber,
                                cardStatus: cardStatus
                            }
                        }];
            }
        });
    });
}
//# sourceMappingURL=kpo_card.js.map